import * as React from "react";
import { UitkCard, UitkCardContent, UitkCardTextSegment } from "uitk-react-cards";
import { viewContext } from "../CheckPrices";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkHeading } from "uitk-react-text";
import { UitkCarousel } from "uitk-react-carousel";
import { useLocalization } from "@shared-ui/localization-context";

interface ContainerProps {
  id: string;
  fmId: number;
  fmTitleId?: number;
  title: string;
  view: string;
  subHeadline: string;
  dataType: string;
}

export const Container: React.FC<ContainerProps> = (props) => {
  const view = React.useContext(viewContext);

  switch (view) {
    case "horizontal-data-display":
      return <RowViewContainer {...props} />;
    case "horizontal-card-carousel":
      return <CarouselViewContainer {...props} />;
    default:
      return <DefaultContainer {...props} />;
  }
};

const DefaultContainer: React.FC<Omit<ContainerProps, "view">> = ({
  children,
  fmId,
  fmTitleId,
  id,
  title,
  subHeadline,
}) => (
  <div className="CheckPrices all-y-padding-three" id={id} data-fm={fmId} data-fm-title-id={fmTitleId}>
    <UitkCard className="all-b-padding-three">
      <UitkCardContent>
        <UitkCardTextSegment className="all-y-padding-four">
          <UitkHeading level={2} size={600}>
            {title}
          </UitkHeading>
          {subHeadline && <span className="uitk-type-300 uitk-type-regular all-t-margin-one">{subHeadline}</span>}
        </UitkCardTextSegment>
        {children}
      </UitkCardContent>
    </UitkCard>
  </div>
);

const RowViewContainer: React.FC<Omit<ContainerProps, "view">> = ({
  children,
  fmId,
  fmTitleId,
  id,
  title,
  subHeadline,
}) => (
  <section
    className="CheckPrices uitk-card uitk-cell uitk-flex-column all-x-padding-four all-y-padding-three all-y-margin-three"
    id={id}
    data-fm={fmId}
    data-fm-title-id={fmTitleId}
  >
    <h2 className="uitk-type-heading-500">{title}</h2>
    {subHeadline && <span className="uitk-type-300 uitk-type-regular all-t-margin-one">{subHeadline}</span>}
    <UitkLayoutFlex className="all-t-padding-two" space="two" wrap="wrap">
      {children}
    </UitkLayoutFlex>
  </section>
);

const CarouselViewContainer: React.FC<Omit<ContainerProps, "view">> = ({
  children,
  fmId,
  fmTitleId,
  id,
  title,
  subHeadline,
}) => {
  const { formatText } = useLocalization();

  return (
    <section
      className="CheckPrices all-y-padding-three all-x-padding-three"
      id={id}
      data-fm={fmId}
      data-fm-title-id={fmTitleId}
    >
      <h2 className="uitk-type-heading-500">{title}</h2>
      {subHeadline && <span className="uitk-type-300 uitk-type-regular all-t-margin-one">{subHeadline}</span>}
      <UitkCarousel
        className="CarouselView all-t-margin-three"
        carouselName="DestinationCards"
        buttonText={{
          nextButton: formatText("carousel.item.next"),
          prevButton: formatText("carousel.item.prev"),
        }}
        itemsVisible={{ sm: 2, md: 3, lg: 3 }}
        pageBy={1}
        peekWidth={12}
      >
        {children}
      </UitkCarousel>
    </section>
  );
};
